export default (that) => [
  {
    text: that.$l('menu_label_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_label_edit') || '编辑会议',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ expoMeetingStatus }) => ['D', 'E'].includes(expoMeetingStatus),
  },
  {
    text: that.$l('menu_label_cancel') || '取消会议',
    icon: 'el-icon-delete',
    menuType: 'cancel',
    allow: 'D',
    disabled: ({ expoMeetingStatus }) => ['D', 'E'].includes(expoMeetingStatus),
  },
  {
    text: that.$l('menu_label_confirm') || '会议确认',
    icon: 'el-icon-check',
    menuType: 'confirm',
    divided: true,
    allow: 'C',
    disabled: ({ expoMeetingStatus }) => !['N'].includes(expoMeetingStatus),
  },
]
